import { Directive } from "@angular/core";

/**
 * Marker directive applied to content projected into the description slot of
 * `ExpandableFormSectionComponent`'s header. Applies the `mgd-form-section-header-description`
 * host class and exists so `ExpandableFormSectionComponent` can detect via
 * `@ContentChild` whether a consumer projected header-description content at all,
 * and conditionally render the description wrapper only when it did.
 *
 * @example
 * ```html
 * <mgd-expandable-form-section>
 *   <span mgdFormSectionIcon><mat-icon>distance</mat-icon></span>
 *   <span mgdFormSectionHeader>Subform Component</span>
 *   <span mgdFormSectionHeaderDescription>Additional context about this section.</span>
 *   ...
 * </mgd-expandable-form-section>
 * ```
 *
 * @selector [mgdFormSectionHeaderDescription]
 */
@Directive({
    selector: "[mgdFormSectionHeaderDescription]",
    host: {
        class: "mgd-form-section-header-description"
    }
})
export class FormSectionHeaderDescriptionDirective {
}
